import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-work-sans\",\"display\":\"swap\"}],\"variableName\":\"workSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/components/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/PreferencesModalWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientCountryProvider"] */ "/app/src/components/i18n/ClientCountryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/components/i18n/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/ConditionalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountrySelectionModalProvider"] */ "/app/src/components/providers/CountrySelectionModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteDomainProvider"] */ "/app/src/components/providers/SiteDomainProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SWRProvider"] */ "/app/src/components/providers/SWRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UtmAttributionTracker"] */ "/app/src/components/providers/UtmAttributionTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterPopupProvider"] */ "/app/src/context/NewsletterPopupContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreferencesModalProvider"] */ "/app/src/context/PreferencesModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProfileProvider"] */ "/app/src/hooks/use-user.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
